import React from 'react';
import { Box, Stack, Typography } from '@mui/material';

import RawHtml from '../../legacy/components/base/RawHtml';

// ********************************************************************************
// The secondary banner component has multiple layouts to work with.
// This is the column layout, which display in a single column the title and
// description.
type Props = {
  title: string;
  description: string;
};
export const SecondaryBannerColumnLayout = (props: Props) => (
  <Stack gap={2} alignItems="flex-start" justifyContent="center" textAlign="center">
    <Typography variant="h2" color="#3F2B56" fontFamily="Gotham-Medium" fontSize="32px" align="left">
      {props.title}
    </Typography>
    <Box color="#302F2F" fontSize="16px" lineHeight="19.2px" fontFamily="Gotham-Book" textAlign="left">
      <RawHtml content={props.description} />
    </Box>
  </Stack>
);
